import { render, staticRenderFns } from "./bindStudent.vue?vue&type=template&id=52f1f534&"
import script from "./bindStudent.vue?vue&type=script&lang=js&"
export * from "./bindStudent.vue?vue&type=script&lang=js&"
import style0 from "./bindStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports